import React from "react";
import { Box, Chip, IconButton, Switch, Tooltip, Typography, alpha, useTheme, } from "@mui/material";
import { Edit } from "iconsax-react";
import TrashIcon from "../icons/TrashIcon";
import { SettingCardWrapper } from "./SettingCardWrapper";
export const SettingUserCard = ({ user, isCurrentUser, canUpdate, canDelete, onStatusChange, onEdit, onDelete, }) => {
    const theme = useTheme();
    return (React.createElement(SettingCardWrapper, null,
        React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 1 } },
            React.createElement(Tooltip, { title: isCurrentUser ? "U kunt uw eigen status niet wijzigen" : "", arrow: true },
                React.createElement("span", null,
                    React.createElement(Switch, { checked: user.status, onChange: (_event, checked) => onStatusChange(user, checked), size: "small", color: "primary", disabled: !canUpdate || isCurrentUser }))),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                React.createElement(Typography, { variant: "h6", noWrap: true }, user.name),
                React.createElement(Typography, { variant: "body2", noWrap: true, sx: {
                        color: "text.secondary",
                    } }, user.email)),
            React.createElement(Box, { sx: { display: "flex", flexShrink: 0 } },
                canUpdate && (React.createElement(Tooltip, { title: isCurrentUser
                        ? "U kunt uw eigen account niet bewerken"
                        : "Gebruiker bewerken", arrow: true },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", onClick: () => onEdit(user), disabled: isCurrentUser, sx: {
                                border: "none",
                                color: isCurrentUser ? "action.disabled" : "primary.main",
                                "&:hover": {
                                    backgroundColor: isCurrentUser
                                        ? "transparent"
                                        : alpha(theme.palette.primary.main, 0.08),
                                },
                            } },
                            React.createElement(Edit, { size: 20, variant: "Bulk" }))))),
                canDelete && (React.createElement(Tooltip, { title: isCurrentUser
                        ? "U kunt uw eigen account niet verwijderen"
                        : "Gebruiker verwijderen", arrow: true },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", onClick: () => onDelete(user), disabled: isCurrentUser, sx: {
                                border: "none",
                                color: isCurrentUser ? "action.disabled" : "error.main",
                                "&:hover": {
                                    backgroundColor: isCurrentUser
                                        ? "transparent"
                                        : alpha(theme.palette.error.main, 0.08),
                                },
                            } },
                            React.createElement(TrashIcon, { size: 20 }))))))),
        React.createElement(Box, { sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1.5,
                gap: 1,
            } },
            React.createElement(Box, null, user.roleName && (React.createElement(Chip, { label: user.roleName, size: "small", sx: {
                    borderRadius: "24px",
                    color: "#2476A9",
                    backgroundColor: "#3192D026",
                    fontWeight: 500,
                } }))),
            React.createElement(Tooltip, { title: user.companies.join(", "), arrow: true },
                React.createElement(Chip, { label: `${user.companies.length} Bedrijven`, size: "small", sx: {
                        borderRadius: "24px",
                        color: "#54801A",
                        backgroundColor: "#86B84529",
                        fontWeight: 500,
                    } })))));
};
